import React from "react";
import { useField } from "formik";
import {
  FormControl,
  FormControlLabel,
  Checkbox as MuiCheckbox,
  Stack,
  Typography,
  FormHelperText,
} from "@mui/material";

interface Props {
  label: string;
  name: string;
  options: Array<{
    is_selected: boolean;
    label: string;
    value: string;
  }>;
  display_format: {
    type?: string;
    column?: string;
  };
  onChange:(field:any)=>void;
  formField:any;
  errorMessage: string;
  isRequired?:any
}

const CheckboxField: React.FC<Props> = ({
  label,
  name,
  options,
  display_format,
  onChange,
  formField,
  errorMessage,
  isRequired
}) => {
  const [field, meta, helpers] = useField(name);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    const newValue = event.target.checked
      ? [...field.value, value]
      : field.value.filter((val: any) => val !== value);
    helpers.setValue(newValue);
    onChange({...formField,value:newValue,options:formField.options.map((option: { value: string; is_selected: boolean }) => ({
      ...option,
      is_selected: Array.isArray(newValue) ? newValue.includes(option.value) : option.value === newValue
    }))})
  };

  return (
    <FormControl error={meta.touched && !!meta.error}>
      <Typography component="h2" sx={{ mt: 1 ,fontFamily: 'Open Sans !important',}}>
        {`${label} ${isRequired ? "*":""}`}
      </Typography>
      <Stack direction={display_format.type  as "row" | "row-reverse" | "column" | "column-reverse"} flexWrap={'wrap'}>
        {options.map((option, index) => (
          <FormControlLabel
            key={index}
            control={
              <MuiCheckbox
              id="checkbox"
                checked={field.value.includes(option.value)}
                onChange={(event) => handleChange(event, option.value)}
                color="success"
                sx={{ color: "#1976d2" }}
              />
            }
            label={option.label}
          />
        ))}
      </Stack>
      {meta.touched && meta.error && (
        <FormHelperText>{errorMessage}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CheckboxField;
